export const apiBaseUrl = {
  "local": "https://gateway-front-external-test.nioint.com/moat/101762",
  "dev": "https://gateway-front-external-test.nioint.com/moat/101762",
  "test": "https://gateway-front-external-test.nioint.com/moat/101762",
  "stg": "https://gateway-front-external-stg.nio.com/moat/101762",
  "prod": "https://gateway-front-external.nio.com/moat/101762"
}

export const h5BaseUrl = {
  "local": "https://app-test.nioint.com/pe/h5pages-nio/module_10094",
  "dev": "https://app-dev.nioint.com/pe/h5pages-nio/module_10094",
  "test": "https://app-test.nioint.com/pe/h5pages-nio/module_10094",
  "stg": "https://app-stg.nio.com/pe/h5pages-nio/module_10094",
  "prod": "https://app.nio.com/pe/h5pages-nio/module_10094"
}